import { api } from "../../api/apiSlice";

export const dashboardApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getDashboard: builder.query({
      query: () => ({ url: "/dashboard", method: "GET" }),
      providesTags: ["Dashboard"],
    }),
    // Built 2026-08-25 for Flutter's home screen/dashboard badges - reused
    // as-is here (see project memory) rather than duplicated: one row per
    // module the caller can act on right now, keyed by App_Modules code.
    getPendingApprovals: builder.query({
      query: () => ({ url: "/dashboard/pending-approvals", method: "GET" }),
    }),
  }),
  overrideExisting: false,
});

export const { useGetDashboardQuery, useGetPendingApprovalsQuery } = dashboardApi;
